import { appendLocaleSources } from '../../hooks/useTranslate'
import InspectionPresenter from '../../api/InspectionPresenter'

appendLocaleSources({
  [InspectionPresenter.urn]: {
    page: {
      title: 'Журнал обхода',
    },
  },
}, 'ru')

appendLocaleSources({
  [InspectionPresenter.urn]: {
    page: {
      title: 'Inspection Log',
    },
  },
}, 'en')

appendLocaleSources({
  [InspectionPresenter.urn]: {
    page: {
      title: 'Tekshirish jurnali',
    },
  },
}, 'uz')



